const tabs = document.querySelectorAll(".tab");
const tabContents = document.querySelectorAll(".tab-content");

for (let i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener("click", () => {
        for (let j = 0; j < tabContents.length; j++) {
            tabContents[j].classList.remove("tab-content--active");
        }
        for (let jj = 0; jj < tabs.length; jj++) {
            tabs[jj].classList.remove("tab--active");
            tabs[jj].classList.remove("tab--active");
            tabs[jj].setAttribute("aria-selected", "false");
        }
        tabContents[i].classList.add("tab-content--active");
        tabs[i].classList.add("tab--active");
        tabs[i].setAttribute("aria-selected", "true");
    });
}
